import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import { Analytics } from '~/pages/Analytics/Analytics';

const ANALYTICS_ROUTE: RouteObject[] = [
  {
    path: PATH.ANALYTICS,
    element: <Analytics />,
  },
];

export { ANALYTICS_ROUTE };
